import { LOGIN_SUCCESS } from './currentUser';

const GET_MEMBER_NOTIFICATIONSETTINGS_REQUEST = 'GET_MEMBER_NOTIFICATIONSETTINGS_REQUEST';
const GET_MEMBER_NOTIFICATIONSETTINGS_SUCCESS = 'GET_MEMBER_NOTIFICATIONSETTINGS_SUCCESS';
const GET_MEMBER_NOTIFICATIONSETTINGS_FAILURE = 'GET_MEMBER_NOTIFICATIONSETTINGS_FAILURE';

const SET_MEMBER_NOTIFICATIONSETTINGS_REQUEST = 'SET_MEMBER_NOTIFICATIONSETTINGS_REQUEST';
const SET_MEMBER_NOTIFICATIONSETTINGS_SUCCESS = 'SET_MEMBER_NOTIFICATIONSETTINGS_SUCCESS';
const SET_MEMBER_NOTIFICATIONSETTINGS_FAILURE = 'SET_MEMBER_NOTIFICATIONSETTINGS_FAILURE';

const initState = {
    settings: null
};

import * as backend from 'backend-helpers/memberNotificationSetting';

export default function memberNotificationSetting(state = initState, action) {

    if (action.type === LOGIN_SUCCESS) {
        state = null;
    }

    if (action.type === GET_MEMBER_NOTIFICATIONSETTINGS_SUCCESS) {

        return {
            ...state,
            ...action.result.data
        }
    }


    if (action.type === SET_MEMBER_NOTIFICATIONSETTINGS_SUCCESS) {
        const settings = JSON.parse(action.data.settings);

        return {
            ...state,
            settings
        }
    }

    return state;
}

export function getMemberNotificationSettings(data) {
    return {
        types: [GET_MEMBER_NOTIFICATIONSETTINGS_REQUEST, GET_MEMBER_NOTIFICATIONSETTINGS_SUCCESS, GET_MEMBER_NOTIFICATIONSETTINGS_FAILURE],
        promise: backend.getMemberNotificationSettings(data),
        data
    }
}

export function setMemberNotificationSettings(data) {
    return {
        types: [SET_MEMBER_NOTIFICATIONSETTINGS_REQUEST, SET_MEMBER_NOTIFICATIONSETTINGS_SUCCESS, SET_MEMBER_NOTIFICATIONSETTINGS_FAILURE],
        promise: backend.setMemberNotificationSettings(data),
        data
    }
}


// WEBPACK FOOTER //
// ./src/reducers/memberNotificationSetting.js